<template>
    <div class="">
        <net-pa-card :Classes="'bg-red'">
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-qrcode text-dark ml-3"></i> ایجاد لینک پرداخت </h6>
              </template>
              <template slot="content">
                <div class="text-center alert alert-custom">
                    <span class="h6 text-secondary">برای ایجاد لینک برای حساب  </span>
                    <span class="h6 text-custom font-weight-bold mx-2">{{ Taahodat.desNoe }}</span>
                    <span class="h6 text-secondary"> با شماره حساب </span>
                    <span class="h6 text-custom font-weight-bold mx-2" dir="rtl">{{ Taahodat.vCode }}</span>
                    <span class="h6 text-secondary">اطلاعات زیر را تکمیل کنید</span>
                </div>
                <div class="row" id="formLinlPay">
                    <div class="col-xl-2 col-6 text-xl-left text-center mt-3">
                        <h6 class="mt-2 d-inline">ساخت لینک به مبلغ</h6><small class="d-inline mt-2 text-danger mr-1">(ریال)</small>
                    </div>
                    <div class="col-xl-2 col-6 mt-2">
                        <input type="text" class="form-control text-center 3ragham required" placeholder="مبلغ"  @keyup="amount=$Comma3ragham(amount)" @keypress="$ValidNumber($event,18,false)" v-model="amount"/>
                    </div>
                    <div class="col-xl-1 col-6 text-center mt-2">
                        <h6 class="mt-2">  به نام </h6>
                    </div>
                    <div class="col-xl-3 col-6 mt-2">
                        <input type="text" class="form-control text-center required"  placeholder="نام و نام خانوادگی" v-model="fullName"/>
                    </div>
                    <div class="col-xl-2 col-6 text-center mt-2">
                        <h6 class="mt-2"> و ارسال لینک به شماره </h6>
                    </div>
                    <div class="col-xl-2 col-6 mt-2">
                        <input type="number" class="form-control text-center required" placeholder="موبایل" @keypress="$ValidNumber($event,11,true)" v-model="mobile"/>
                    </div>
                    <div class="col-xl-2 col-12 text-center mt-2">
                        <h6 class="mt-2"> توضیحات لینک </h6>
                    </div>
                    <div class="col-xl-8 col-12 mt-2">
                        <input type="text" class="form-control text-center" placeholder="توضیحات" v-model="Description"/>
                    </div>
                    <div class="col-xl-2 col-12 text-center mt-2">
                        <button class="btn btn-success w-100 mt-1" @click="CreateLink"> <i class="fa fa-qrcode ml-2"></i> ساخت لینک</button>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="border-custom"></div>
                    </div>
                </div>
                <!-- {{Taahodat}} -->
              </template>
            </net-pa-card>
    </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
export default {
  components: { NetPaCard },
    data() {
        return {
            amount:null,
            fullName:'',
            mobile:null,
            Description:''
        }
    },
    props:['Taahodat'],
    methods:{
        CreateLink(){
            console.log(this.mobile);
            
            if (this.$ValidForm('formLinlPay')) {
                if (this.mobile.length==11) {
                    this.$SweetQustion('توجه','لینک پرداخت ایجاد شده به نام '+this.fullName+' به مبلغ '+ this.$Comma3ragham(this.amount)+' ریال '+' می باشد و به شماره  '+this.mobile+'ارسال خواهد شد ، از موارد فوق و ارسال لینک اطمینان دارید؟','warning','ارسال لینک','لغو',null,this.Confirm,this.cancel)
                }
                else{
                    this.$mySweetDefaultTost('موبایل نا معتبر', 'شماره موبایل وارد شده نا معتبر می باشد', 'error', 2800)
                }
            }
        },
        Confirm(){
            let data={
                Id:0,
                wwwtblTaahodatId:this.Taahodat.id,
                Name:this.fullName,
                Amount:Number(this.amount.replace(',','')),
                Mobile:this.mobile,
                Des:this.Description,
                IsUse:false,
                DateTimeInsert:this.$GetJalaliDate()
            }
            
            this.$PostData_new('LinkPay/Add','POST',data,false)
            .then((res)=>{
                if (res.status=="Ok") {
                    this.$mySweetDefault('عملیات موفق', 'لینک پرداخت شما با موفقیت ارسال گردید', 'success', 2800)
                }
                else{
                    this.$mySweetDefault('عملیات ناموفق', 'خطا در ارسال لینک پرداخت', 'error', 2800)
                }
            })
        }
    },
    mounted(){
        if (!this.Taahodat) {
            this.$router.go(-1)
        }
    }
}
</script>
<style scoped>
.alert-custom{
    border:2px dashed #be5915 ;
    background: #be59152c ;
}
.text-custom{
    color:#be5915;
}
.border-custom{
    border-bottom: 2px dashed #be5915 ;
}
</style>